const EMAIL_ALERT_CONFIG = { pattern: /\/email-alert-api\/.+/, version: '1.0' };
const ANALYSIS_CONFIG = { pattern: /\/analysis-api\/.+/, version: '2.0' };
const CORE_BASIC_CONFIG = { pattern: /\/core-basic-api\/.+/, version: '2.0' };
const CORE_SEARCH_CONFIG = { pattern: /\/core-search-api\/.+/, version: '2.0' };
const WORKSPACE_CONFIG = { pattern: /workspace\/web\/.+/, version: '2.0' };
const MARKETPLACE_CONFIG = { pattern: /\/marketplace-api\/.+/, version: '1.0' };
const PASSPORT_PRIVILEGE_CONFIG = { pattern: /user\/tips\/privilege_renew/, version: '1.0' };
const ACCOUNT_SERVICE_CONFIG = { pattern: /\/user-service\/.+/, version: '1.0' };
export const PRESETS_TOKEN_BASE_WORKSPACE = {
    name: 'workspace',
    excludesUrlRegExps: [
        WORKSPACE_CONFIG,
        MARKETPLACE_CONFIG,
        ANALYSIS_CONFIG,
        CORE_BASIC_CONFIG,
        EMAIL_ALERT_CONFIG,
        CORE_SEARCH_CONFIG,
        { pattern: /^\/(\w+-)+api\/.+/, version: '1.0' },
        PASSPORT_PRIVILEGE_CONFIG,
        ACCOUNT_SERVICE_CONFIG,
        { pattern: /http(s)?:\/\//, version: '2.0' },
    ],
    apiVersion: '2.0',
};
export const PRESETS_TOKEN_BASE_MARKETPLACE = {
    name: 'marketplace',
    excludesUrlRegExps: [
        CORE_BASIC_CONFIG,
        WORKSPACE_CONFIG,
        MARKETPLACE_CONFIG,
        { pattern: /^\/(\w+-)+api\/.+/, version: '1.0' },
        PASSPORT_PRIVILEGE_CONFIG,
    ],
    apiVersion: '1.0',
};
